// src/data/aggregation.js

export const calculateAggregationFromData = (processedTasks, columns, includeTotal = false) => {
  const aggregationData = [];
  if (!processedTasks || processedTasks.length === 0) return aggregationData;
  
  const tasks = processedTasks.filter(task => !task.isGroupHeader);
  const aggregationColumns = columns.filter(col => 
    col.type === 'aggregation' || col.aggregation === true
  );
  
  if (includeTotal && tasks.length > 0) {
    aggregationColumns.forEach(column => {
      const columnKey = column.key;
      const sum = tasks.reduce((acc, task) => {
        const value = task.data?.[columnKey];
        const numValue = parseFloat(value);
        return acc + (isNaN(numValue) ? 0 : numValue);
      }, 0);
      aggregationData.push({ id: 0, idColumn: columnKey, value: sum });
    });
  }
  
  const groups = processedTasks.filter(task => task.isGroupHeader && task.groupId !== null);
  
  if (groups.length > 0) {
    const groupMap = new Map();
    groups.forEach(group => { if (group.groupId) groupMap.set(group.groupId, group); });
    
    const tasksByGroup = {};
    tasks.forEach(task => {
      if (task.groupId && groupMap.has(task.groupId)) {
        if (!tasksByGroup[task.groupId]) tasksByGroup[task.groupId] = [];
        tasksByGroup[task.groupId].push(task);
      }
    });
    
    Object.entries(tasksByGroup).forEach(([groupId, groupTasks]) => {
      aggregationColumns.forEach(column => {
        const columnKey = column.key;
        const sum = groupTasks.reduce((acc, task) => {
          const value = task.data?.[columnKey];
          const numValue = parseFloat(value);
          return acc + (isNaN(numValue) ? 0 : numValue);
        }, 0);
        aggregationData.push({ id: groupId, idColumn: columnKey, value: sum });
      });
    });
  }
  
  return aggregationData;
};

export const getAggregationValueById = (itemId, columnKey, aggregationData) => {
  if (!aggregationData || aggregationData.length === 0 || !itemId) return null;
  const aggregationItem = aggregationData.find(agg => agg.idColumn === columnKey && agg.id == itemId);
  return aggregationItem ? aggregationItem.value : null;
};

export const getTotalAggregationValue = (columnKey, aggregationData) => {
  if (!aggregationData || aggregationData.length === 0) return null;
  const totalAggregation = aggregationData.find(item => item.id == 0 && item.idColumn === columnKey);
  return totalAggregation ? totalAggregation.value : null;
};